import { styled, DefaultTheme } from "@styles";
import { Container } from "react-bootstrap";

type WrapperProps = {
  theme: DefaultTheme;
};

export const Wrapper = styled.div``;

export const ShareContainer = styled(Container)`
  margin-bottom: 2rem;
`;

export const ShareTitle = styled.h2`
  color: #ff6958;
  text-align: center;
  margin-top: 3rem;
  margin-bottom: 1.5rem;
  text-transform: uppercase;
`;

export const ShareSubtitle = styled.h3`
  text-align: center;
`;

export const ClickToCopyText = styled.p`
  text-align: center;
  text-transform: uppercase;
  font-size: 1.5rem;
  margin-top: 2rem;
`;

export const CopyResult = styled.p`
  text-align: center;
  text-transform: uppercase;
  font-size: 1rem;
  margin-top: 1rem;
  color: ${props => props.theme.colors.primary};
`;

export const ReceivedPoint = styled.h2`
  text-align: center;
  font-size: 1.3rem;
`;

export const TncHeader = styled.h2`
  font-size: 1.5rem;
`;

export const TncContent = styled.ul`
  list-style: disc;
`;